// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"GoogleConnect_pageHeader__22pSZ","add":"GoogleConnect_add__8HE-O"};